import { useMemo } from 'react'

import { useMask, UseMaskProps } from './useMask'

export type UseMaskedValueProps = UseMaskProps & {
  value: string
}

export const useMaskedValue = ({ value, mask, markSymbol }: UseMaskedValueProps) => {
  const { clean, apply } = useMask({ mask, markSymbol })

  const cleanNewValue = (newValue: string) => {
    if (!mask) {
      return newValue
    }

    return clean(newValue)
  }

  const formatValue = (newValue: string) => apply(newValue)

  const formattedValue = useMemo(() => apply(value), [apply, value])

  return {
    formattedValue,
    cleanNewValue,
    formatValue,
  }
}
